<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <input type="hidden" name="menuType" id="menuType" value="secure" />
        <h2 id="pageTitle">{{ 'bss.admin.selectUserAccErr.title' | translate }}</h2>
        <hr>
    </div>
</div>

<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <div class="ontario-table-container ontario-small-12 ontario-medium-12 ontario-large-12">
            <p>{{ 'bss.admin.confirmReq.description' | translate }} - {{ userRoleDetails.role.roleName }}</p>
        </div>

        <div class="ontario-alert ontario-alert--error" *ngIf="searchResultscount === 0" aria-live="polite" aria-atomic="true">
            {{ 'bss.admin.selectUserAccErr.error.noMatch.description' | translate }}
        </div>

        <div class="ontario-alert ontario-alert--error" *ngIf="searchResultscount > 0" aria-live="polite" aria-atomic="true">
            {{ getTooManyMessage() }}
        </div>

        <button tabindex="102" (click)="onBack()" class="ontario-button ontario-button--secondary"
            title="{{ 'bss.admin.selectUserAccErr.back.title' | translate }}">
            {{ 'bss.admin.selectUserAccErr.back' | translate }}
        </button>
    </div>
</div>
<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
      <button class="ontario-button ontario-button--secondary"  tabindex="103"
      title="{{ 'bss.admin.selectUserAcc.newSearch.title' | translate }}" (click)="onNewSearch()">
      {{ 'bss.admin.selectUserAcc.newSearch' | translate }}
    </button>
    </div>
  
  </div>